import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "@/lib/api";
import { useI18n } from "@/i18n";
import { useAuth } from "@/lib/auth";
import { toast } from "sonner";

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
export default function Login() {
  const { lang } = useI18n();
  const { refresh } = useAuth();
  const navigate = useNavigate();
  const [tab, setTab] = useState("client");
  const [loading, setLoading] = useState(false);
  const [team, setTeam] = useState({ email: "", password: "" });

  const startGoogle = () => {
    const redirectUrl = window.location.origin + "/portal";
    window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
  };

  const teamLogin = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await api.post("/team/login", { email: team.email, password: team.password });
      toast.success(lang === "fr" ? "Bienvenue" : "Welcome");
      navigate("/team", { replace: true });
    } catch (err) {
      const msg = err?.response?.data?.detail;
      toast.error(typeof msg === "string" ? msg : (lang === "fr" ? "Identifiants incorrects" : "Invalid credentials"));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="max-w-md mx-auto px-6 pt-24 pb-32">
      <div className="overline text-[#D4AF37]">{lang === "fr" ? "Espace privé" : "Private area"}</div>
      <h1 className="font-serif font-light text-4xl md:text-5xl text-[#0A1128] mt-6 text-center">
        {lang === "fr" ? "Connectez-vous." : "Sign in."}
      </h1>

      <div className="flex gap-1 mt-12 border-b border-[#0A1128]/10">
        <button
          onClick={() => setTab("client")}
          className={`flex-1 py-3 text-xs tracking-[0.24em] uppercase transition-colors ${tab === "client" ? "text-[#0A1128] border-b-2 border-[#D4AF37]" : "text-[#0A1128]/50 hover:text-[#0A1128]"}`}
          data-testid="tab-client"
        >
          {lang === "fr" ? "Client" : "Client"}
        </button>
        <button
          onClick={() => setTab("team")}
          className={`flex-1 py-3 text-xs tracking-[0.24em] uppercase transition-colors ${tab === "team" ? "text-[#0A1128] border-b-2 border-[#D4AF37]" : "text-[#0A1128]/50 hover:text-[#0A1128]"}`}
          data-testid="tab-team"
        >
          {lang === "fr" ? "Équipe" : "Team"}
        </button>
      </div>

      {tab === "client" && (
        <div className="mt-8" data-testid="client-login-panel">
          <p className="text-sm text-[#0A1128]/70 text-center">
            {lang === "fr"
              ? "Accès sécurisé pour vos documents et itinéraires. Authentification par Google."
              : "Secure access to your documents and itineraries. Google-powered sign-in."}
          </p>
          <button
            onClick={startGoogle}
            className="mt-8 bg-[#0A1128] text-[#F9F8F6] px-10 py-4 text-xs tracking-[0.24em] uppercase hover:bg-[#D4AF37] hover:text-[#0A1128] transition-colors duration-500 w-full"
            data-testid="login-google"
          >
            {lang === "fr" ? "Continuer avec Google" : "Continue with Google"}
          </button>
        </div>
      )}

      {tab === "team" && (
        <form onSubmit={teamLogin} className="mt-8 space-y-5" data-testid="team-login-form">
          <p className="text-sm text-[#0A1128]/70 text-center">
            {lang === "fr" ? "Réservé aux membres de l'équipe." : "Reserved for team members."}
          </p>
          <div>
            <label className="overline text-[#0A1128]/60">Email</label>
            <input
              type="email"
              required
              value={team.email}
              onChange={(e) => setTeam({ ...team, email: e.target.value })}
              className="w-full bg-transparent border-b border-[#0A1128]/30 py-3 focus:outline-none focus:border-[#D4AF37]"
              data-testid="team-email"
            />
          </div>
          <div>
            <label className="overline text-[#0A1128]/60">{lang === "fr" ? "Mot de passe" : "Password"}</label>
            <input
              type="password"
              required
              value={team.password}
              onChange={(e) => setTeam({ ...team, password: e.target.value })}
              className="w-full bg-transparent border-b border-[#0A1128]/30 py-3 focus:outline-none focus:border-[#D4AF37]"
              data-testid="team-password"
            />
          </div>
          <button
            type="submit"
            disabled={loading}
            className="bg-[#0A1128] text-[#F9F8F6] px-10 py-4 text-xs tracking-[0.24em] uppercase hover:bg-[#D4AF37] hover:text-[#0A1128] transition-colors duration-500 w-full disabled:opacity-60"
            data-testid="team-submit"
          >
            {loading ? "..." : (lang === "fr" ? "Se connecter" : "Sign in")}
          </button>
        </form>
      )}
    </div>
  );
}
